<template>
  <content-dialog
    :visible.sync="modalVisible"
    max-width="800px"
  >
    <!--<editor-fold desc="Dialog Header">-->
    <template slot="dialogTitle">
      <span v-if="yachtTypeDirty.id">
        Edit Yacht Type
      </span>
      <span v-else>
        Add New Yacht Type
      </span>
    </template>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Form">-->
    <v-card-text :class="{'pa-5': !$vuetify.breakpoint.xsOnly }">
      <v-text-field
        v-model="yachtTypeDirty.label"
        v-validate="'required'"
        name="label"
        label="Label"
        placeholder="e.g. Catamaran"
        outlined
        :error-messages="veeErrors.collect('label')"
      />
    </v-card-text>
    <!--</editor-fold>-->

    <!--<editor-fold desc="Dialog Actions">-->
    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="submitting"
        @click="submit"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Save
      </v-btn>
    </template>
    <!--</editor-fold>-->
  </content-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import ContentDialog from '@/components/helpers/Dialog'
import YachtType from '@/models/YachtType'

export default {
  name: 'YachtTypeEditDialog',
  components: {
    ContentDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    yachtType: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      yachtTypeDirty: cloneDeep(YachtType.emptyModel),
      submitting: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  watch: {
    yachtType() {
      this.yachtTypeDirty = cloneDeep(this.yachtType)
    }
  },
  methods: {
    async submit() {
      let validation = await this.$validator.validate()

      if (!validation) return

      this.save()
    },
    async save() {
      this.submitting = true

      let data = {
        label: this.yachtTypeDirty.label
      }

      try {
        await YachtType.api.save(data, this.yachtTypeDirty.id)

        this.$emit('update:yachtType')

        this.$store.dispatch('alert', {
          'text': 'Yacht Type saved',
          'color': 'success'
        })
        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          'text': 'Something went wrong',
          'color': 'error'
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
